// extracted by mini-css-extract-plugin
export var loadingSpinner = "_21-0";
export var spinnerContainer = "_21-1";